import { IOptimizelyFlags, IOptimizelyFlagVariations } from "app/models/Optimizely/Optimizely";

export const optimizelyInitialState: IOptimizelyFlags = {
  totalPages: 0,
  count: 0,
  page: 0,
  totalCount: 0,
  items: [],
  error: undefined
};

export const optimizelyVariationInitialState: IOptimizelyFlagVariations = {
  count: 0,
  items: [],
  lastUrl: '',
  firstUrl: '',
  totalPages:0,
  totalCount: 0,
  createUrl: '',
  page: 0,
  error: undefined
}